// extracted by mini-css-extract-plugin
export var displayNone = "_kf-6";
export var imgContainer = "_kf-2";
export var overflowHidden = "_kf-3";
export var productInfoCardButtonContainer = "_kf-5";
export var productTitleText = "_kf-4";
export var rightArrow = "_kf-1";
export var rightArrowContainer = "_kf-0";